import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {catchError} from 'rxjs/operators';
import {throwError} from 'rxjs';
import {GlobalErrorService} from '../services/global-error.service';
import {isCustomHandledStatus} from './http-errror-handling.registry';
import {isHoomvipApiRequest, SILENT_HTTP_REQUEST} from './http-api-scope';

export const apiErrorsInterceptor: HttpInterceptorFn = (req, next) => {
  const globalError = inject(GlobalErrorService);

  if (!isHoomvipApiRequest(req.url)) {
    return next(req);
  }

  const silent = req.context.get(SILENT_HTTP_REQUEST);

  return next(req).pipe(
    catchError((err: unknown) => {
      const anyErr = err as any;
      const status = typeof anyErr?.status === 'number' ? anyErr.status : undefined;

      if (!isCustomHandledStatus(status)) {
        if (err instanceof HttpErrorResponse || status != null) {
          globalError.scheduleHttpError(err, silent);
        }
      }

      return throwError(() => err);
    })
  );
};
